// src/components/PassMapCard.jsx
import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import indiaStates from "../data/indiaStates.json";

export default function PassMapCard({
  currentPass,
  questionNumber,
  loading,
  mapScale,
}) {
  return (
    <div className="map-card">
      <div className="map-card-header">
        <span>Map of India – Passes / Ghats</span>
        <span>
          Question:{" "}
          <strong style={{ color: "#e5e7eb" }}>{questionNumber}</strong>
        </span>
      </div>

      <div className="map-inner">
        {loading ? (
          <div className="map-loading">Loading map…</div>
        ) : (
          <div className="map-center-wrapper">
            <ComposableMap
              projection="geoMercator"
              projectionConfig={{
                center: [82.5, 22.5],
                scale: mapScale,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <Geographies geography={indiaStates}>
                {({ geographies }) =>
                  geographies.map((geo) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      style={{
                        default: {
                          fill: "rgba(148,163,184,0.35)",
                          outline: "none",
                          stroke: "#1f2937",
                          strokeWidth: 0.7,
                        },
                        hover: {
                          fill: "rgba(209,213,219,0.9)",
                          outline: "none",
                        },
                        pressed: {
                          fill: "#e5e7eb",
                          outline: "none",
                        },
                      }}
                    />
                  ))
                }
              </Geographies>

              {currentPass && currentPass.coordinates && (
                <Marker coordinates={currentPass.coordinates}>
                  <circle
                    r={5}
                    className="pass-marker"
                    fill="#f97316"
                    stroke="#fde68a"
                    strokeWidth={1}
                  />
                </Marker>
              )}
            </ComposableMap>
          </div>
        )}
      </div>
    </div>
  );
}
